<template>
  <div class="box-collaborator__container">
    <div class="flex mr-2 box-collaborator h-9">
      <ul :class="`flex box-${list.length}`">
        <li
          v-for="(collaborator, index) in listCollaborator"
          :key="collaborator.userId"
          v-tooltip="collaboratorTooltip(collaborator, index)"
          class="presenter-avatar"
        >
          <aha-avatar
            :name="collaborator.name"
            :image="collaborator.avatar"
            :id="collaborator.id"
            class="avatar"
          />
        </li>
        <li
          class="cursor-pointer presenter-avatar more"
          v-if="list.length > 3"
          @click="$emit('openShareToEditPopup')"
        >
          +{{ list.length - 3 }}
        </li>
      </ul>
      <button
        class="share-button-desktop"
        v-tooltip="'Invite to edit'"
        @click="$emit('openShareToEditPopup')"
        v-if="inviteToEditVisible"
      >
        <aha-icon name="invite" class="icon-invite" />
        Invite
      </button>
    </div>
    <div class="flex share-button-mobile">
      <aha-button
        variant="base"
        @click="$emit('openShareToEditPopup')"
      >
        <aha-icon name="invite" class="icon-invite" color="#333" />
      </aha-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import constants from '@/constant'

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      workingMode: (state) => state.workingMode,
      presentation: (state) => state.presentation,
      userOnlineByPresentationId: (state) => state.userOnlineByPresentationId,
    }),
    inviteToEditVisible() {
      return this.currentUser.identifyProvider !== 'skoletube'
    },
    isABTestCollabTeamEdit() {
      if (this.presentation.accountId &&
        !this.presentation.hasSharedUser && this.presentation.accountId % 2 === 0) {
        return true
      }
      return false
    },
    listCollaborator() {
      if (!this.isABTestCollabTeamEdit) {
        return this.list.slice(0, 3)
      }
      if (!this.userOnlineByPresentationId || !this.presentation) {
        return []
      }
      const userOnlineByPresentation = this.userOnlineByPresentationId[this.presentation.id]
      if (!userOnlineByPresentation) {
        return []
      }
      const allUser = {}
      Object.keys(userOnlineByPresentation).forEach((slideId) => {
        const listUserInSlide = userOnlineByPresentation[slideId]
        listUserInSlide.forEach((userActive) => {
          allUser[userActive.user.id] = userActive.user
        })
      })
      const newList = []
      this.list.forEach((user) => {
        if (allUser[user.id]) {
          newList.push(user)
        }
      })
      return newList.slice(0, 3)
    },
  },

  methods: {
    collaboratorTooltip(collaborator) {
      let role = 'Editor'
      if (collaborator.accountRole === constants.workspace.VIEWER && this.workingMode === constants.workspace.TEAM) {
        role = 'Viewer'
      }
      let textForMyData = ''
      if (collaborator.isMyData) {
        textForMyData = ' (you)'
      }
      return `<div class="text-center"><strong>${collaborator.name}</strong>${textForMyData} </br> ${role}<div>`
    },
  },
}
</script>

<style lang="scss" scoped>
.box-collaborator {
  @apply bg-secondary-15;
  border-radius: 19px;
  padding: 4px;

  .presenter-avatar {
    @apply w-7 h-7 rounded-full text-center;
    line-height: 26px;
    margin-right: -5px;

    .avatar {
      border: 1px solid #FFFFFF;
      font-size: 10px;
      font-weight: bold;
    }

    &:nth-child(1) {
      z-index: 4;
    }
    &:nth-child(2) {
      z-index: 3;
    }
    &:nth-child(3) {
      z-index: 2;
    }
    &:nth-child(4) {
      z-index: 1;
    }

    &:last-child {
      margin-right: 5px;
    }

    &.more {
      @apply bg-secondary-50 text-base-0;
      font-size: 10px;
      font-weight: bold
    }
  }
}

.share-button-desktop {
  @apply bg-base-0 hover:bg-secondary-10 outline-none;
  @apply h-7 px-1 inline-block font-bold cursor-pointer whitespace-nowrap transition-colors;
  border-radius: 14px;
  padding: 4px;

  .icon-invite {
    position: relative;
    top: -2px;
  }
}

.share-button-mobile {
  display: none;
}

@media (max-width: 1024px) {
  .box-collaborator {
    display: none;
  }

  .share-button-mobile {
    display: block;
    margin-right: 8px;
    margin-top: -2px;
    &::v-deep button {
      min-width: 1.2rem;
      height: 28px;
    }
  }
}
</style>
